import { createSlice } from '@reduxjs/toolkit'

export interface IUserStateType {
  userInfo: IUserInfoType | any,
  loginStatus: boolean,
  completed: boolean
}
export interface IUserInfoType {
  name: string
  tel: string
  [key: string]: any
}
export const initialState:IUserStateType = {
  userInfo: {},
  loginStatus: false,
  completed: false
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = Object.assign({}, action.payload)
    },
    setLoginStatus: (state, action) => {
      state.loginStatus = action.payload
    },
    setCompleted: (state, action) => {
      state.completed = action.payload
    }
  }
})
export const { setUserInfo, setLoginStatus, setCompleted } = userSlice.actions
export default userSlice.reducer